import { CreditNoteRepository } from "../../repositories/CreditNoteRepository";
import {
  CreditNoteCountsEntity,
  CreditNoteDocumentType,
} from "../../entities/CreditNoteEntity";

/**
 * Get Credit Note Counts Use Case
 * Retrieves counts for all credit note categories for dashboard cards
 */
export class GetCreditNoteCountsUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(params?: {
    date_from?: string;
    date_to?: string;
    document_type?: CreditNoteDocumentType;
  }): Promise<CreditNoteCountsEntity> {
    return await this.repository.fetchCreditNoteCounts(params);
  }
}
